import './index.css';

export type {SkinnyBannerProps} from './SkinnyBanner';
export {default as default} from './SkinnyBanner';
